import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';
import { isServiceRequestViewType, ServiceRequestViewFilters, TableView, UseTableViewsOptions } from './types';

function transformTableView(view: TableView): TableView {
  if (!isServiceRequestViewType(view.type)) {
    return view;
  }

  const filters = view.filters as ServiceRequestViewFilters;
  const { service, ...rest } = filters;
  return {
    ...view,
    filters: {
      ...rest,
      service,
    },
  };
}

export function useTableViews(options: UseTableViewsOptions = {}) {
  const { type, role, enabled = true } = options;

  const query = new URLSearchParams();
  if (type) {
    query.append('type', type);
  }
  if (role) {
    query.append('role', role);
  }

  const {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  }: {
    data?: {
      count: number;
      tableViews: TableView[];
    };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
    isLoading: boolean;
    isValidating: boolean;
  } = useSWR(
    enabled ? `${API_BASE_PATH}?${query.toString()}` : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  const transformedViews = (data?.tableViews || []).map(transformTableView);

  return {
    data: transformedViews,
    count: data?.count || 0,
    error,
    mutate,
    isLoading,
    isValidating,
  };
}
